import React, { useContext } from 'react';
import { Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
// import _ from 'lodash-es';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
// 引入ButtonStyled 组件
import { ButtonMLStyled } from './ButtonMLStyled';
// import commStyles from '@/comm.less?modules';

/**
 * 头部OK按钮
 * @param {*} param
 */
const ButtonML = ({
  value,
  size,
  onClick,
  disabled = false,
  icon,
  type,
  shape,
  htmlType,
  width = 'auto',
  height = 'auto',
  fontsize = '16px',
  className,
  downIcon = false,
}) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);

  function click(e) {
    e.preventDefault();
    e.stopPropagation();
    onClick && onClick();
  }
  return (
    <ButtonMLStyled
      theme={themeContext}
      width={width}
      height={height}
      fontsize={fontsize}
      brand={brandContext}
      className={type}
    >
      <div className={type ? type : 'primary'}>
        {onClick ? (
          <Button
            className={className}
            icon={icon}
            disabled={disabled}
            shape={shape}
            type={type}
            size={size ? size : 'small'}
            onClick={click}
            htmlType={htmlType}
          >
            {value}
            {downIcon ? <DownOutlined /> : ''}
          </Button>
        ) : (
          //为了避免为from按按钮时候的一些默认click事件
          <Button
            className={className}
            icon={icon}
            disabled={disabled}
            shape={shape}
            type={type}
            size={size ? size : 'small'}
            htmlType={htmlType}
          >
            {value}
            {downIcon ? <DownOutlined /> : ''}
          </Button>
        )}
      </div>
    </ButtonMLStyled>
  );
};

export default ButtonML;
